import React from "react";
import { Steps, ConfigProvider } from "antd";

import { Colors } from "../../config";

import "./styles.css";

const AppjourneySteps = (props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: Colors.main,
        },
      }}
    >
      <Steps
        current={props?.array?.length - 1}
        direction="vertical"
        items={props?.array?.map((item, index) => ({
          title: (
            <div className="flex flex-col gap-2 font-bold text-[1.25em]">
              <div className="flex gap-2">{item.title}</div>
            </div>
          ),
          description: (
            <div className="font-semibold text-[1.125em] text-justify">
              {item?.details}
            </div>
          ),

          icon: (
            <div className="h-7 w-7 rounded-full bg-main text-white text-[14px] font-semibold flex justify-center items-center">
              {index + 1}
            </div>
          ),
        }))}
        className="app-journey-steps"
        {...props}
      />
    </ConfigProvider>
  );
};

export default AppjourneySteps;
